// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-numbers.current a,.page-numbers:hover a{color:#fff!important}.catalog--empty{text-align:center;font-size:22px}", ""]);
// Exports
module.exports = exports;
